import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=59f98215&scoped=true"
import script from "./GeneralSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSetting.vue?vue&type=script&lang=js"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=59f98215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f98215",
  null
  
)

export default component.exports